import React from 'react';
import moment from 'moment';
import GraphView from './GraphView';
import $ from 'jquery';

class Observation extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      observations: null,
      data: {
        data: [],
        categories: [],
        series_name: [],
      },
      titleText: '',
      options: null
    };
  }

  componentWillMount() {
    this.onView(this.props.series)

  }

  componentWillReceiveProps() {
    this.onView(this.props.series)

  }


  isBetween = (parameter) => {
    let between = null;

    if (parameter) {
      between = parameter.filter(obs => moment(obs.datetime).isBetween(moment().subtract(24, 'hours'), moment()));
    }
    return between;
  }


  onView = (observations) => {
    let observation = this.isBetween(observations.data);

    const dataState = this.state.data;
    dataState.data = (observation && observation.map(observation => parseFloat(observation.value))) || [];
    dataState.categories = (observation && observation.map(observation => moment.utc(observation.datetime))) || [];
    dataState.series_name = observations.name;
    const seriesData = (observation &&
      observation.map(({ datetime, value }) => {
        // return [(new Date(datetime)).valueOf(), value];
        return [moment.utc(datetime).add({ hours: 5, minutes: 45 }).valueOf(), value];
      })
    ) || [];
    this.setState({
      data: dataState, seriesData
    });
  }

  graphValue = (state, props) => {
    let { seriesData } = state;
    let { series, station: { warningLevel, dangerLevel } } = props;
    // console.log(series);
    // warningLevel = 589.15;
    // dangerLevel = 943.09;

    let width = $(window).width();

    let plotLines = [];
    if (warningLevel) {
      plotLines.push({
        value: +warningLevel,
        color: 'orange',
        width: 1,
        label: {
          text: 'Warning Level'
        },
        zIndex: 3
      })
    }
    if (dangerLevel) {
      plotLines.push({
        value: +dangerLevel,
        color: 'red',
        width: 1,
        label: {
          text: 'Danger Level'
        },
        zIndex: 3
      })
    }

    if (series.data && series.data.length > 0) {
      return {
        chart: {
          type: 'line',
          // height: 200,
          height: width / 8,
          width: 1300,
          zoomType: 'x',
          style: {
            width: '100%',
            fontSize: '12px'
          }
        },
        series: [{
          name: 'Value',
          showInLegend: false,
          data: this.isBetween(series.data).map(({ datetime, value }) => ([moment.utc(datetime).add({ hours: 5, minutes: 45 }).valueOf(), value])),
          marker: {
            enabled: true,
            radius: 1
          },
          states: {
            hover: {
              lineWidthPlus: 0
            }
          }
        }],
        title: {
          text: ''
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b'
          },
          lineWidth: 0,
          lineColor: 'transparent',
          minorTickLength: 0,
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: ''
          },
          plotLines,
          // min: 942.8,
          // max: dangerLevel
        },
        credits: false
      };
    } else {
      return {
        chart: {
          type: 'line',
          height: 100
        },
        series: [{
          name: 'Value',
          showInLegend: false,
          data: []
        }],
        title: {
          text: ''

        },
        xAxis: {
          type: 'datetime',
          categories: [],
          lineWidth: 0,
          lineColor: 'transparent',
          minorTickLength: 0,
          tickLength: 0,
          dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b'
          }
        },
        yAxis: {
          title: {
            text: ''
          },
          plotLines
        },
        credits: false
      };
    }
  }

  render() {
    return (
      <div className='inline-it'>
        <div className="graph">
          <h1 className="webkitCenter">{this.props.station.name}</h1>
          <GraphView options={this.graphValue(this.state, this.props)} />
        </div>

      </div>
    );
  }
}

export default Observation;


// WEBPACK FOOTER //
// ./src/component/graph/Observation.js